import { render, staticRenderFns } from "./package-bookings-needing-actioning-widget.vue?vue&type=template&id=6373a8e2&"
import script from "./package-bookings-needing-actioning-widget.vue?vue&type=script&lang=js&"
export * from "./package-bookings-needing-actioning-widget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports